import {
  DEFAULT_ICON_COLOR,
  DEFAULT_ICON_OPACITY,
  DEFAULT_ICON_SIZE,
} from 'app-constants';
import { memo } from 'react';

import type { AppIconProps } from '../app-icon.types';

export const CalendarIcon = memo(
  ({
    size = DEFAULT_ICON_SIZE,
    color = DEFAULT_ICON_COLOR,
    opacity = DEFAULT_ICON_OPACITY,
  }: AppIconProps) => {
    const { width, height } = size;

    return (
      <svg
        fill="none"
        height={height}
        viewBox="0 0 18 18"
        width={width}
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity={opacity}>
          <path
            d="M2.25 6.75V13.5C2.25 15.1569 3.59315 16.5 5.25 16.5H12.75C14.4069 16.5 15.75 15.1569 15.75 13.5V6.75M2.25 6.75V5.625C2.25 3.96815 3.59315 2.625 5.25 2.625H12.75C14.4069 2.625 15.75 3.96815 15.75 5.625V6.75M2.25 6.75H15.75M12 1.5V3.75M6 1.5V3.75"
            stroke={color}
            strokeLinecap="round"
          />
        </g>
      </svg>
    );
  },
);
